<template>
  <div class="frozen-container" ref="frozenContainer">
    <div class="btn-wrapper" ref="headerContainer" id="table-header-wrapper">
      <div class="title"> 已冻结账号
        <el-tooltip class="item" effect="dark" content="冻结期间账号仍可正常登录使用广联达产品" placement="right">
          <i class="w-icon-wenhao title-icon"></i>
        </el-tooltip>
      </div>
      <div class="btns">
        <w-button :disabled="(selectedAccountArr.length===0)" @click="mutiDeleteAccount" ghost>批量删除</w-button>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="dataList"
        :height="tableHeight"
        empty-text=" "
        class="zjy-table-class"
        row-class-name="table-row-class"
        cell-class-name="cell-class-name"
        header-row-class-name="header-row-class-name"
        header-cell-class-name="header-cell-class-name"
        @select="handleSelectChange"
        @select-all="handleSelectAllChange"
      >
          <el-table-column
          type="selection"
          width="55"/>
          <el-table-column
            prop="account"
            label="员工账号"
            min-width="200"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            show-overflow-tooltip
            min-width="200">
          </el-table-column>
          <el-table-column
            prop="latestLoginTime"
            width="180"
            label="最后登录日期">
          </el-table-column>
          <el-table-column
            label="操作"
            align="right"
            width="140">
            <template slot-scope="{row}" >
              <span @click="deleteAccount(row)" class="operation-btn">删除</span>
              <span @click="activeAccount(row)" class="operation-btn">激活</span>
            </template>
          </el-table-column>
      </el-table>
    </div>
    <div ref="pagenationContainer" class="text-align-right padding-top-5" v-if="dataList.length">
      <w-pagination @current-change="handleCurrentChange" @size-change="handlePageSizeChange"
        :current-page.sync="pagination.pageNum" background layout="total, prev, pager, next, jumper,sizes"
        :page-size="pagination.pageSize" :page-sizes="[50, 100]" :total="pagination.total"></w-pagination>
    </div>

    <!-- 账号激活 弹窗 -->
    <w-dialog
      @close="handlerClose"
      :show="showActiveAccount"
      class="activiting-class"
      :title="`账号激活`"
      :wallStyle="{ zIndex: 2001 }"
      :box-style="{ width: '500px', zIndex: 2001 }"
      :bodyStyle="{ padding: '20px 24px 0 24px' }"
      :footerStyle="{
        padding: '24px',
        borderTop: 'none'
      }"
    >
      <div class="warnning-tips">为保证企业资产信息安全，请完成用户身份校验后激活当前账号</div>
      <w-form
        ref="accountForm"
        :model="accountForm"
        label-width="100px"
        :rules="accountRules"
      >
        <w-form-item label="密保手机号" prop="phone">
          <w-input
            class="width-full"
            size="small"
            v-model.trim="accountForm.phone"
            placeholder="请输入手机号"
          ></w-input>
        </w-form-item>
        <w-form-item label="验证码" prop="captcha">
          <w-input
            class="width-full"
            size="small"
            clearable
            style="width: 242px; margin-right: 10px;"
            v-model.trim="accountForm.captcha"
            placeholder="请输入验证码"
          ></w-input>
          <w-button style="width: 100px; paddingLeft: 0; paddingRight: 0;" type="minor" :disabled="!/^1[3456789]{1}\d{9}$/.test(accountForm.phone) || !accountForm.timer==0" @click.prevent.stop>
            <Countdown :time="accountForm.timer" @click.native="getVerification" @finish="accountForm.timer=0" />
          </w-button>
        </w-form-item>
      </w-form>
       <!-- 网易易盾 -->
       <div  ref="captcha"></div>
      <div slot="footer">
        <w-button type="primary" size="small" @click="handlerActive">确认激活</w-button>
        <w-button size="small" type="minor" @click="handlerClose">取消</w-button>
      </div>
    </w-dialog>
  </div>
</template>

<script>
import Vue from 'vue'

import manageService from '@/assets/service/manage'
import LoginService from '@/assets/service/login'

import { aes, appId, captchaId } from '@/assets/utils/CommonUtil'

import Countdown from '_c/common/countDown'
import {Table, TableColumn} from 'element-ui'


Vue.use(Table)
Vue.use(TableColumn)

let captchaIns
export default {
  name: 'frozenList',
  components: {
    Countdown
  },
  data (){
    const validatePhone = (rule, value, callback) => {
      console.log(value, value === '')
      if (value === '') {
        return callback(new Error('不能为空'))
      } else if (!/^1[3456789]{1}\d{9}$/.test(value)) {
        return callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    // 请输入验证码
    const validateCode = (rule, value, callback) => {
      console.log(value, value === null)
      if (value === null) {
        return callback(new Error('不能为空'))
      } else if (!Number(value)) {
        return callback(new Error('请输入正确的验证码'))
      } else {
        callback()
      }
    }
    return {
      tableHeight: 400,

      loading: false,
      selectedAccountArr: [],

      showActiveAccount: false,

      row: {},
      dataList: [],
      pagination: {
        total: 0,
        current: 1,
        pageNum: 1,
        pageSize: 50,
        showSizeChanger: true,
        showQuickJumper: true,
        hideOnSinglePage: true
      },
      accountForm: {
        phone: '',
        captcha: null,
        timer: 0
      },
      accountRules: {
        phone: [
          {validator: validatePhone, trigger: 'blur'}
        ],
        captcha: [
          {validator: validateCode, trigger: 'blur'}
        ]
      }
    }
  },
  created (){

  },
  destroyed () {
    window.removeEventListener('resize', this.getTableHeight)
  },
  mounted (){

    this.getEmployeeList()
    window.addEventListener('resize', this.getTableHeight)
    this.initNECaptchaDom()
  },
  methods: {

    // 动态计算表格高度
    getTableHeight () {
      this.$nextTick(() => {
        if (this.dataList.length > 0) {
          this.tableHeight =
            this.$refs.frozenContainer.clientHeight -
            this.$refs.headerContainer.clientHeight -
            this.$refs.pagenationContainer.clientHeight -
            110
        }
      })
    },
    // 获取员工列表-已冻结
    getEmployeeList () {
      this.loading = true

      let params = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        deleted: 0,
        departmentId: '',
        excludeRoleIdMember: false,
        extrasInfo: false
      }
      manageService.getEmployeeList(params).then(res => {
        const {code, data, message} = res
        console.log(res)
        this.loading = false
        if (code === 200){
          const {items, total} = data
          this.dataList = items
          this.pagination.total = total

        } else {
          this.$message.error(message)
        }
        this.selectedAccountArr = []

        this.getTableHeight()

      }).catch(() => {
        this.$message.error('获取账号列表失败')
        this.loading = false
        this.dataList = []
      })
    },
    // 批量删除
    mutiDeleteAccount (){
      console.log(this.selectedAccountArr)
      let gldUserIdList = this.selectedAccountArr.map(item => { return item.gldUserId })
      this.sentLog(100117114)
      this.$confirm({
        type: 'warning',
        width: 400,
        message: '确定批量删除员工吗？',
        tips: '员工将从公司组织中删除，并收回产品权限',
        multipleSubmit: [
          {type: 'primary', name: '确定', key: 'open', value: 1}, // 删除确认弹窗 确定 按钮灰显
          {type: 'minor', name: '取消', key: 'open', value: 0} // 删除确认弹窗 取消 按钮亮显
        ],
        submit: data => {
          // console.log(data)
          if (data && +data.open === 1) {
            manageService.deleteEmployees(gldUserIdList).then(res => {
              const {code, data, message} = res
              if (code === 200){
                this.$message.success(`成功删除${data}个账号`)
                this.getEmployeeList()
                this.sentLog(100117115, {number: data})
              } else {
                this.$message.error(message)
              }
            }).catch(() => {
              this.$message.error('账号删除失败')
            })
          }
        },
        noCancelBtn: true
      })

    },
    deleteAccount (row){
      let message = ''
      this.sentLog(100117116)
      this.$confirm({
        type: 'warning',
        width: 400,
        message: '确定要删除员工吗？',
        tips: '员工将从公司组织中删除，并收回产品权限',
        multipleSubmit: [
          {type: 'primary', name: '确定', key: 'open', value: 1}, // 删除确认弹窗 确定 按钮灰显
          {type: 'minor', name: '取消', key: 'open', value: 0} // 删除确认弹窗 取消 按钮亮显
        ],
        submit: data => {
          // console.log(data)
          if (data && +data.open === 1) {
            manageService.deleteEmployee({gldUserId: row.gldUserId}).then(res => {
              if (res.code === 200) {
                manageService.addRelationLog({
                  area: this.userInStore.area,
                  detail: row.account,
                  operateType: 'DELETE_ACCOUNT',
                  relType: '',
                  showState: 1
                })
                this.$message.success('账号成功删除')
                this.getEmployeeList()
                this.sentLog(100117117)
              } else {
                switch (+res.code) {
                  // case 330027:
                  //   this.$message.error(res.message)
                  //   break
                  case 340014:
                    message = '删除员工失败，用户正在登录'
                    this.$message.error(message)
                    break
                  case 340037:
                    message =
                      '当前员工账号正在联网或借出使用产品，请退出使用或归还后，再尝试删除'
                    this.$confirm({
                      message: '删除失败',
                      type: 'warning',
                      tips: message,
                      submitText: '我知道了',
                      noCancelBtn: true
                    })
                    break
                  default:
                    message = res.message || '删除员工失败'
                    this.$message.error(message)
                }
              }
              // that.sentLog(100117034, {status, message})
            })
          }
        },
        noCancelBtn: true
      })
    },
    activeAccount (row){
      this.row = row
      this.showActiveAccount = true
      this.sentLog(100117118)
    },
    // 1.1 网易易盾初始化
    initNECaptchaDom () {
      let that = this
      window.initNECaptcha({
        element: this.$refs.captcha, // 验证码容器元素ID
        captchaId, // 由用户中心分配
        mode: 'bind',
        width: '320px',
        onVerify (err, data) {
          console.error(err)
          // 用户验证码验证成功后，进行实际的提交行为
          if (data) {
            that.verifyCallback({validate: data.validate, captchaId})
          }
        }
      }, instance => {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        captchaIns = instance
      }, err => {
        // 初始化失败后触发该函数，err对象描述当前错误信息
        console.log(err)
      })
    },
    // 1.2获取验证吗
    getVerification (){
      captchaIns && captchaIns.verify()
    },
    // 1.3 网易易盾验证成功回调
    verifyCallback (verifyOptions = {}) {
      captchaIns && captchaIns.refresh()
      // 获取短信
      let time = new Date().getTime()
      let query = {
        appId,
        sign: aes(time, this.accountForm.phone),
        t: time
      }
      let params = {
        captchaCode: verifyOptions.validate,
        captchaId,
        mobile: this.accountForm.phone
      }
      LoginService.getMobileCode(query, params).then((res) => {
        console.log(res)
        if (res.code === 200) {
          this.accountForm.timer = 60
        } else {
          this.$message.error(res.message || '获取验证码失败')
        }
      }).catch((e) => {
        console.error(e)
        this.$message.error('获取验证码失败')
      })
    },
    // 处理激活账号逻辑
    handlerActive (){
      this.$refs['accountForm'].validate((valid) => {
        if (valid) {
          const params = {
            mobile: this.accountForm.phone,
            verifyCode: this.accountForm.captcha,
            gldUserId: this.row.gldUserId,
            account: this.row.account
          }
          manageService.activeEmployees(params).then(res => {
            console.log(res)
            if (res.code === 200) {
              manageService.addRelationLog({
                area: this.userInStore.area,
                detail: `${params.account}`,
                operateType: 'UNFREEZE_ACCOUNT',
                relType: '',
                showState: 1
              })
              this.accountForm.timer = 60
              this.$message.success('账号已成功激活')
              this.getEmployeeList()
              this.handlerClose()
              this.sentLog(100117119)
            } else {
              this.$message.error(res.message || '账号激活失败')
            }
          })
        } else {
          return false
        }
      })
    },
    // 关闭弹框
    handlerClose (){
      this.$refs['accountForm'].resetFields()
      this.showActiveAccount = false
    },
    handleSelectChange (selection){
      console.log(selection)
      this.selectedAccountArr = [...selection]
    },

    // 全选操作
    handleSelectAllChange (selection){
      console.log(selection)
      this.selectedAccountArr = [...selection]
    },
    // 分页
    handleCurrentChange (index){
      this.pagination.pageNum = index
      this.getEmployeeList()
    },
    handlePageSizeChange (index){
      this.pagination.pageSize = index
      this.pagination.pageNum = 1
      this.getEmployeeList()
    }
  }
}
</script>
<style lang="less" type="text/less" scoped>
.frozen-container {
  padding: 24px 25px;
  height: 100%;
  .btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      width: 120px;
      height: 24px;
      line-height: 24px;
      font-size: 16px;
      font-weight: bold;
      color: #212530;
      display: flex;
      &-icon {
        font-size: 17px;
        margin-left: 10px;
        color: rgba(33, 37, 48, 0.55);
      }
    }
  }
  .table-wrapper{
    margin-top: 20px;
  }
}

</style>
<style lang="less">
.activiting-class{
  .warnning-tips{
    padding: 8px 12px;
    margin-bottom: 20px;
    background: #FFFBDA;
    border: 1px solid #ECDBA5;
    font-size: 12px;
    color: rgba(33,37,48,0.8);
  }
}
.zjy-table-class{
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #2079FA;
    border-color: #cce0ff;
  }
 &.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
    background-color: #f3f4f7;
  }
  &::before{
    height: 0;
  }
  .header-row-class-name{
    box-shadow: 0px 1px 0px 0px rgba(33,37,48,0.1);
  }
  .header-cell-class-name{
    &.is-right .cell{
      padding-right: 16px;
    }
    background-color: #F3F4F7 !important;
    color: rgba(33,37,48,0.8);
    padding: 8px 0;
  }
  .table-row-class{

  }
  .cell-class-name{
    color: rgba(33,37,48,0.8);
  }
  .operation-btn{
    margin-right: 14px;
    &:first-child{
      margin-right: 16px;
    }
    color: #2079FA;
    cursor: pointer;
  }
}
</style>
